import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { authAPI } from '../../services/api';

const LoginTest = () => {
  const [email, setEmail] = useState('test2@example.com');
  const [password, setPassword] = useState('password');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);
    
    try {
      const response = await authAPI.login({ email, password });
      setResult({
        status: response.status,
        data: response.data
      });
      
      // Store token in localStorage for testing
      if (response.data.data?.token) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
      }
    } catch (err) {
      console.error('Login error:', err);
      setError({
        message: err.message,
        response: err.response?.data
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setResult({ status: 200, message: 'Logged out successfully' });
  };

  const checkToken = () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      setResult({
        status: 200,
        message: 'Token found',
        data: {
          token: token,
          user: JSON.parse(user)
        }
      });
    } else {
      setError({
        message: 'No token found',
        response: null
      });
    }
  };

  return (
    <Container className="py-5">
      <h1 className="mb-4">Login API Test</h1>
      
      <Card className="mb-4">
        <Card.Header>Test Login</Card.Header>
        <Card.Body>
          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
              />
            </Form.Group>
            
            <div className="d-flex gap-2">
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? 'Testing...' : 'Test Login'}
              </Button>
              <Button variant="secondary" onClick={checkToken} disabled={loading}>
                Check Token
              </Button>
              <Button variant="danger" onClick={handleLogout} disabled={loading}>
                Logout
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      
      {error && (
        <Alert variant="danger">
          <h5>Error</h5>
          <pre>{JSON.stringify(error, null, 2)}</pre>
        </Alert>
      )}
      
      {result && (
        <Alert variant="success">
          <h5>Result</h5>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </Alert>
      )}
    </Container>
  );
};

export default LoginTest;
